export default __webpack_public_path__ + "static/Hero-cdf554312d3862f1723441b4ba42d2f4.png";